import { Add } from '@mui/icons-material';
import { Button, Tooltip } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DialogCreateDonation from './DialogCreateDonation';
import useAuth from 'src/hooks/useAuth';

const CreateDonationButton = ({ 'data-tour': dataTour, ...rest }) => {
  const [openCreateDonation, setOpenCreateDonation] = useState(false);
  const { user } = useAuth();
  const businessIsActive = !!user?.is_business_visible_to_others;
  const { t } = useTranslation('translation', {
    keyPrefix: 'sidebar',
  });
  return (
    <>
      {openCreateDonation && (
        <DialogCreateDonation
          open={openCreateDonation}
          onClose={() => setOpenCreateDonation(false)}
        />
      )}
      <Tooltip
        disableInteractive
        title={
          !businessIsActive
            ? t('organization-disabled', { context: 'donation' })
            : t('create-donation')
        }
      >
        <span data-tour={dataTour} {...rest}>
          <Button
            disabled={!businessIsActive}
            onClick={() => setOpenCreateDonation(true)}
            startIcon={<Add />}
          >
            {t('create-donation')}
          </Button>
        </span>
      </Tooltip>
    </>
  );
};

export default CreateDonationButton;
